export default {
  title: 'Przegląd firmy',
  description: 'Witaj ponownie, {{name}}! Oto co dzieje się z Twoim marketingiem.',
};
